const UrlUtils = {
    isValid: (urlString: string): boolean => {
        try {
            const url = new URL(urlString);
            return url.protocol.indexOf('http') === 0;
        } catch (error) {
            return false;
        }
    },
    strip: (url: string): string => {
        const regex = /^(https?:\/\/)?(www\.)?([^/]+)(\/)?$/;
        return url.replace(regex, '$3');
    },
    ensureWww: (url: string): string => {
        const regex = /^(https?:\/\/)?([^/]+)(\/.*)?$/;
        return url.replace(regex, (match, protocol, domain, path) => {
            const domainParts = domain.split('.');
            // Only add www if it's not already present and if it's a top-level domain (not a subdomain)
            if (domainParts.length <= 2 && domainParts[0] !== 'www') {
                return `www.${domain}`;
            }
            return `${domain}`;
        });
    },
};

export default UrlUtils;
